/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _reduxRouterLibConstants = require('redux-router/lib/constants');

var _helpersGetDataDependencies = require('../../helpers/getDataDependencies');

var _helpersGetDataDependencies2 = _interopRequireDefault(_helpersGetDataDependencies);

var locationsAreEqual = function locationsAreEqual(locA, locB) {
	return locA.pathname === locB.pathname && locA.search === locB.search;
};

exports['default'] = function (_ref) {
	var getState = _ref.getState;
	var dispatch = _ref.dispatch;
	return function (next) {
		return function (action) {
			if (action.type === _reduxRouterLibConstants.ROUTER_DID_CHANGE) {
				var _ret = (function () {
					if (getState().router && locationsAreEqual(action.payload.location, getState().router.location)) {
						return {
							v: next(action)
						};
					}

					var _action$payload = action.payload;
					var components = _action$payload.components;
					var location = _action$payload.location;
					var params = _action$payload.params;

					var promise = new _Promise(function (resolve) {
						var doTransition = function doTransition() {
							next(action);
							_Promise.all(_helpersGetDataDependencies2['default'](components, getState, dispatch, location, params, true)).then(resolve)['catch'](function (error) {
								// TODO: You may want to handle errors for fetchDataDeferred here
								console.warn('Warning: Error in fetchDataDeferred', error);
								console.log(components, getState, dispatch, location, params);

								return resolve();
							});
						};

						_Promise.all(_helpersGetDataDependencies2['default'](components, getState, dispatch, location, params)).then(doTransition)['catch'](function (error) {
							// TODO: You may want to handle errors for fetchData here
							console.warn('Warning: Error in fetchData', error);
							// console.log('components', components);
							// console.log('getState', getState);
							// console.log('dispatch', dispatch);
							// console.log('location', location);
							// console.log('params', params);

							return doTransition();
						});
					});

					if (__SERVER__) {
						// router state is null until ReduxRouter is created so we can use this to store
						// our promise to let the server know when it can render
						getState().router = promise;
					}

					return {
						v: promise
					};
				})();

				if (typeof _ret === 'object') return _ret.v;
			}

			return next(action);
		};
	};
};

module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/middleware/transitionMiddleware.js
 ** module id = 718
 ** module chunks = 0
 **/